<template>
  <div class="solid-table">
    <el-table :data="tableData">
      <el-table-column
        v-for="col in columns"
        :key="col.prop"
        :prop="col.prop"
        :label="col.label"
        :type="col.type"
      >
        <template slot-scope="scope">
          <div
            class="normal-cell"
            :class="{
              bolder: scope.row.bolder,
              bold: scope.row.bold,
              indent: ['name', 'index'].includes(scope.column.property)
            }"
          >
            {{ scope.row[col.prop] }}
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
const COLUMNS = [
  {
    label: '序号',
    prop: 'index'
  },
  {
    label: '项目名称',
    prop: 'name'
  },
  {
    label: '设备购置费（万元）',
    prop: 'deviceFee'
  },
  {
    label: '建安工程费（万元）',
    prop: 'constructionFee'
  },
  {
    label: '其他费用（万元）',
    prop: 'otherFee'
  },
  {
    label: '合计（万元）',
    prop: 'totalFee'
    // },
    // {
    //   label: '占总投资比例（%）',
    //   prop: 'totalFeeCoefficient'
  }
];
export default {
  props: {
    result: Object
  },
  data() {
    return {
      columns: COLUMNS
    };
  },
  computed: {
    tableData() {
      if (!this.result) return [];
      const { result } = this;
      return [
        {
          bolder: true,
          index: 'Ⅰ',
          name: '风电场'
        },
        {
          bold: true,
          index: '一',
          name: '施工辅助工程',
          constructionFee: result.auxiliaryProjectInstallationFee,
          totalFee: result.auxiliaryProjectTotal
        },
        {
          index: '1',
          name: '施工供电工程',
          constructionFee: result.powerProjectInstallationFee,
          totalFee: result.powerProjectTotal
        },
        {
          index: '2',
          name: '施工供水工程',
          constructionFee: result.waterProjectInstallationFee,
          totalFee: result.waterProjectTotal
        },
        {
          index: '3',
          name: '其他施工辅助工程',
          constructionFee: result.otherAuxiliaryProjectInstallationFee,
          totalFee: result.otherAuxiliaryProjectTotal
        },
        {
          bold: true,
          index: '二',
          name: '设备及安装工程',
          deviceFee: result.equipmentInstallationProjectEquipmentPurchaseFee,
          constructionFee: result.equipmentInstallationProjectInstallationFee,
          totalFee: result.equipmentInstallationProjectTotal
        },
        {
          index: '1',
          name: '发电场设备及安装工程',
          deviceFee: result.windfarmEquipmentInstallProjectEquipmentPurchaseFee,
          constructionFee:
            result.windfarmEquipmentInstallProjectInstallationFee,
          totalFee: result.windfarmEquipmentInstallProjectTotal
        },
        {
          index: '2',
          name: '升压变电站设备及安装工程',
          deviceFee: result.boosterStationInstallProjectEquipmentPurchaseFee,
          constructionFee: result.boosterStationInstallProjectInstallationFee,
          totalFee: result.boosterStationInstallProjectTotal
        },
        {
          index: '3',
          name: '控制保护设备及安装工程',
          deviceFee: result.controlProtectionInstallProjectEquipmentPurchaseFee,
          constructionFee:
            result.controlProtectionInstallProjectInstallationFee,
          totalFee: result.controlProtectionInstallProjectTotal
        },
        {
          index: '4',
          name: '其他设备及安装工程',
          deviceFee: result.otherEquipmentInstallProjectEquipmentPurchaseFee,
          constructionFee: result.otherEquipmentInstallProjectInstallationFee,
          totalFee: result.otherEquipmentInstallProjectTotal
        },
        {
          bold: true,
          index: '三',
          name: '建筑工程',
          constructionFee: result.buildProjectInstallationFee,
          totalFee: result.buildProjectTotal
        },
        {
          index: '1',
          name: '发电场工程',
          constructionFee: result.windfarmProjectInstallationFee,
          totalFee: result.windfarmProjectTotal
        },
        {
          index: '2',
          name: '升压变电工程',
          constructionFee: result.boosterProjectInstallationFee,
          totalFee: result.boosterProjectTotal
        },
        {
          index: '3',
          name: '房屋建筑工程',
          constructionFee: result.housebuildersProjectInstallationFee,
          totalFee: result.housebuildersProjectTotal
        },
        {
          index: '4',
          name: '交通工程',
          constructionFee: result.trafficProjectInstallationFee,
          totalFee: result.trafficProjectTotal
        },
        {
          index: '5',
          name: '其他工程',
          constructionFee: result.otherProjectInstallationFee,
          totalFee: result.otherProjectTotal
        },
        {
          bold: true,
          index: '四',
          name: '其他费用',
          otherFee: result.otherOtherFee,
          totalFee: result.otherTotal
        },
        {
          index: '1',
          name: '项目建设用地费',
          otherFee: result.projectConstructionOtherFee,
          totalFee: result.projectConstructionTotal
        },
        {
          index: '2',
          name: '项目建设管理费',
          otherFee: result.projectConstructionManagementOtherFee,
          totalFee: result.projectConstructionManagementTotal
        },
        {
          index: '3',
          name: '生产准备费',
          otherFee: result.productionPreparationOtherFee,
          totalFee: result.productionPreparationTotal
        },
        {
          index: '4',
          name: '勘察设计费',
          otherFee: result.surveyDesignOtherFee,
          totalFee: result.surveyDesignTotal
        },
        {
          index: '5',
          name: '其他税费',
          otherFee: result.otherTaxesOtherFee,
          totalFee: result.otherTaxesTotal
        },
        {
          bold: true,
          index: '',
          name: '一~四部分合计',
          deviceFee: result.oneFourPurchaseFee,
          constructionFee: result.oneFourInstallationFee,
          otherFee: result.oneFourOtherFee,
          totalFee: result.oneFourTotal
        },
        {
          bold: true,
          index: '五',
          name: '基本预备费',
          totalFee: result.basicReserveTotal
        },
        {
          bold: true,
          index: '',
          name: '工程静态投资（一~五部分合计）',
          totalFee: result.projectStaticInvestmentTotal
        },
        {
          bold: true,
          index: '六',
          name: '价差预备费',
          totalFee: result.priceDifferenceReserveFundTotal
        },
        {
          bold: true,
          index: '七',
          name: '建设期利息',
          totalFee: result.constructionPeriodInterestTotal
        },
        {
          bold: true,
          index: '',
          name: '工程总投资（一~七部分合计）',
          totalFee: result.projectTotalInvestmentTotal
        },
        {
          index: '',
          name: '单位千瓦静态投资（元/kW）',
          totalFee: result.unitKilowattStaticInvestmentTotal
        },
        {
          index: '',
          name: '单位千瓦动态投资（元/kW）',
          totalFee: result.unitKilowattDynamicInvestmentTotal
        },
        {
          bolder: true,
          index: 'Ⅱ',
          name: '送出工程投资',
          totalFee: result.sendOutProjectInvestment
        },
        {
          bolder: true,
          index: 'Ⅲ',
          name: '项目总投资',
          totalFee: result.projectTotalInvestment
        }
      ];
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.el-table__row {
  .normal-cell {
    text-align: right;
    &.bolder {
      font-weight: bolder;
      // &.indent {
      // }
    }
    &.bold {
      font-weight: bold;
      // &.indent {
      // }
    }
  }
}
</style>
